// extracted by mini-css-extract-plugin
export default {"mainContainer":"Layout_mainContainer__TWoUX","container":"Layout_container__PwBHQ","dashboardContainer":"Layout_dashboardContainer__Lx2RY","header":"Layout_header__oDmyr"};